import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.BATCHES;

const BatchesMenuLink: Array<LinkItemProps> = [
  {
    name: "Batches Monitoring",
    link: URL.BATCHES_MONITORING,
    level: 2,
  },
  {
    name: "Batches Errors",
    link: URL.BATCHES_ERRORS,
    level: 2,
  },
  {
    name: "Batches Traces",
    link: URL.BATCHES_TRACES,
    level: 2,
  },
];

export default BatchesMenuLink;
